// extracted by mini-css-extract-plugin
export default {"courseSupport":"styles_courseSupport__QofYv","content":"styles_content__XiKGP"};